import React, {Component} from "react";
import AssociateFilterContextProvider from "./context/AssociateFilterContextV2";
import AssociatePerformanceContextProvider from "./context/AssociatePerformanceContextV2";
import CapabilityContextProvider from "../global/context/CapabilityContext";
import AssociateViewV2 from "./AssociateViewV2";

class AssociatesV2 extends Component {
    render() {
        return (
            <CapabilityContextProvider>
                <AssociateFilterContextProvider>
                    <AssociatePerformanceContextProvider>
                        <AssociateViewV2 history={this.props.history} associate={this.props.match.params.associate}/>
                    </AssociatePerformanceContextProvider>
                </AssociateFilterContextProvider>
            </CapabilityContextProvider>

        )
    }
}

export default AssociatesV2


// WEBPACK FOOTER //
// ./src/components/outboundassociate/AssociatesV2.js